import { render } from "./App.vue?vue&type=template&id=de54cd24"
const script = {}

import "./App.vue?vue&type=style&index=0&id=de54cd24&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.8_vue@3.5.8_typescript@4.8.4__webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__